export const OPEN = 'open'
export const PENDING_CUSTOMER_SERVICE = 'pendingCustomerService'
export const PENDING_FREIGHT_GROUP = 'pendingFreightGroup'
export const IN_TRANSIT = 'inTransit'
export const PRODUCT_RECEIVED = 'productReceived'
export const CLOSED = 'closed'

export const statuses = {
    [OPEN]: {
        text: 'Open',
        value: OPEN,
        icon: 'fas fa-envelope-open-text'
    },
    [PENDING_CUSTOMER_SERVICE]: {
        text: 'Pending Customer Service',
        value: PENDING_CUSTOMER_SERVICE,
        icon: 'fas fa-headphones'
    },
    [PENDING_FREIGHT_GROUP]: {
        text: 'Pending Freight Group',
        value: PENDING_FREIGHT_GROUP,
        icon: 'fas fa-truck-loading'
    },
    [IN_TRANSIT]: {
        text: 'In Transit',
        value: IN_TRANSIT,
        icon: 'fas fa-shipping-fast'
    },
    [PRODUCT_RECEIVED]: {
        text: 'Product Received',
        value: PRODUCT_RECEIVED,
        icon: 'fas fa-box'
    },
    [CLOSED]: {
        text: 'Closed',
        value: CLOSED,
        icon: 'far fa-check-square'
    }
}

export const statusesArray = Object.keys(statuses).map(key => statuses[key])
